import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=2ffd3bbc&"
import script from "./Partner.vue?vue&type=script&lang=ts&"
export * from "./Partner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports